import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { usePCrmServiceCategory, PCrmServiceCategory } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => {
  return (
    <GenericDetailPage<PCrmServiceCategory>
      useData={usePCrmServiceCategory}
      config={{
        ...moduleConfig,
        getDetailSections,
        getStatusBadges,
      }}
    />
  );
};

export default Detail;
